import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  // Lazy-init with the REAL width on first render instead of `undefined`.
  // This app is client-only (no SSR/hydration), so `window` always exists
  // here. The old `undefined` -> `false` (desktop) -> measured value on
  // mount pattern meant every mobile visitor briefly rendered the full
  // desktop layout (row hero, 4-col stats grid, etc.) and then reflowed
  // to the mobile layout a beat later - the main cause of the CLS 0.414
  // ("poor") score in the PageSpeed report.
  const [isMobile, setIsMobile] = React.useState<boolean>(
    () => window.innerWidth < MOBILE_BREAKPOINT
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
